import React, { useEffect, useState } from "react";
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    Grid2,
    Container,
    Link,
    useTheme,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    ThemeProvider,
    createTheme,
    Divider,
    Autocomplete,
    FormHelperText,
} from "@mui/material";
import pwcLogo from "assets/Wrap.png";
import { useNavigate, useParams } from "react-router-dom";
import { useGenerateOtpQuery, useGetKeyIssueQuery, useUpdateWorkFlowMutation, useVerifyOtpMutation } from "store/slices/apis/keyIssueSlice";
import { Formik } from "formik";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';

const currentStatuses = [
    { label: "Open", year: 1994 },
    { label: "Close", year: 1972 }
];

const VerifyIssue = () => {
    const theme = useTheme();
    const { issueId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formDataOtp, setFormDataOtp] = useState({
        'otp': ''
    })

    const [isOtpVerified, setIsOtpVerified] = useState(false)

    const [formData, setFormData] = useState({
        'Status': '',
        ParentId: issueId,
        Comment: '',
        Type: 'issue'
    })
    const { data: keyIssue } = useGetKeyIssueQuery(issueId);
    const { data: generateOtp, isSuccess, isError, error } = useGenerateOtpQuery({ IssueId: issueId });

    const [verifyOtp, verifyOtpRes] = useVerifyOtpMutation();
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateWorkFlowMutation();

    const validationSchema = Yup.object({
        Status: Yup.string().required("Status field is required."),
        Comment: Yup.string().required("Comment field is required."),
    });

    const validationSchemaOtp = Yup.object({
        otp: Yup.number().positive().required("OTP field is required."),
    });

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 7000);

    };

    useEffect(() => {
        if (isSuccess) {
            if (generateOtp?.data) {
                openNotification(`${generateOtp?.message} ${generateOtp?.data}`, 'success')
                // cancel();
            } else {
                openNotification(generateOtp?.message, 'error')
            }
        }
    }, [isSuccess])

    useEffect(() => {
        if (verifyOtpRes?.isSuccess) {
            if (verifyOtpRes?.data?.status == 'Success') {
                openNotification(`${verifyOtpRes?.data?.message}`, 'success')
                navigate(`/verify/issue/${issueId}/updateWorkFlow`, { replace: true })
                // cancel();
            } else {
                openNotification(verifyOtpRes?.data?.message, 'error')
            }
        }
    }, [verifyOtpRes?.isSuccess])

    useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status == 'Success') {
                openNotification(updateWorkFlowRes?.data?.message, 'success')
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
        }

    }, [updateWorkFlowRes?.isSuccess]);

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        if (isOtpVerified) {
            updateWorkFlow({ ...values, ParentId: keyIssue?.data?.id, data: JSON?.stringify(keyIssue?.data) })
            resetForm();
        } else {
            let formValues = { ...values, IssueId: issueId }
            const formData = new FormData();

            Object.keys(formValues).forEach((key) => {
                formData.append(key, formValues[key]);
            });
            verifyOtp(formData)
        }

    }
    const newTheme = createTheme({
        components: {

            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${theme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '15px'
                        },
                        '& .MuiFilledInput-root.Mui-disabled:before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root': {
                            backgroundColor: '#fff'
                        },
                        '& .MuiFilledInput-input': {
                            backgroundColor: 'none',
                            fontSize: '14px'
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                            color: '#696969'
                        },
                        '& .MuiFilledInput-root.Mui-disabled': {
                            backgroundColor: '#fff',
                            color: 'inherit'
                        },
                        '& .MuiFilledInput-input.Mui-disabled': {
                            WebkitTextFillColor: '#696969',
                            opacity: 'none'
                        }

                    },
                },
            }
        },
    });
    return (
        <ThemeProvider theme={newTheme}>
            <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                {/* Top App Bar */}
                <AppBar position="static" sx={{ backgroundColor: "#fff", boxShadow: "none" }}>
                    <Toolbar>
                        <img src={pwcLogo} style={{ width: "7%" }} alt="Logo" />
                    </Toolbar>
                </AppBar>

                <Grid2 container spacing={2} sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f3f3f3" }}>
                    {isError &&
                        <Typography variant="h4">
                            {error?.data}
                        </Typography>
                    }

                    {isSuccess &&
                        generateOtp?.data &&
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Verify OTP
                            </Typography>
                            <Formik
                                initialValues={formDataOtp}
                                validationSchema={validationSchemaOtp}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid2 container spacing={2}>

                                            <Grid2 size={12}>
                                                <TextField
                                                    label="Enter OTP"
                                                    variant="filled"
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                    fullWidth
                                                    value={values?.otp}
                                                    onChange={handleChange}
                                                    name="otp"
                                                    onBlur={() => setTouched({ ...touched, otp: true })}
                                                />
                                                {touched?.otp && errors?.otp &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.otp}`}</FormHelperText>
                                                }
                                            </Grid2>

                                            <Grid2 size={12}>
                                                <Button type='submit' loading={verifyOtpRes?.isLoading} variant="contained" sx={{
                                                    marginRight: '20px',
                                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                                    color: '#FFF', padding: '6px 20px',
                                                    fontWeight: '500', textTransform: 'none',
                                                    fontSize: '16px'
                                                }}>
                                                    Verify OTP
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    </form>
                                )}
                            </Formik>
                        </Grid2>

                    }
                </Grid2>

                {/* Footer */}
                <Box sx={{ py: 2, backgroundColor: "#f5f5f5", textAlign: "center" }}>
                    <Container>
                        <Typography variant="caption" sx={{ color: "#252525", fontSize: "14px" }}>
                            Version: V1.2025 <br />
                            © 2025 PwC (RAD App Local). All rights reserved.
                        </Typography>
                        <Box sx={{ mt: 1 }}>
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Legal Disclaimers
                            </Link>
                            |
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Contact Support
                            </Link>
                            |
                            <Link href="#" color="inherit" sx={{ mx: 1, fontSize: "14px", fontWeight: "400", letterSpacing: "-0.2px" }}>
                                Click me!
                            </Link>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider >
    );
};

export default VerifyIssue;
